import styled from 'styled-components'

export const CardRoot = styled.div.attrs({})`
  display: flex;
  flex-direction: column;
  gap: ${p => p.embedded ? '18px' : '16px'};
  padding: ${p => p.embedded ? '0' : '18px'};
  border-radius: ${p => p.embedded ? '0' : '16px'};
  background: ${p => p.embedded ? 'transparent' : p.theme.palette.colors.backgroundStrong};
  border: ${p => p.embedded ? '0' : `1px solid ${p.theme.palette.colors.borderSoft}`};
  box-shadow: ${p => p.embedded ? 'none' : `0 18px 34px ${p.theme.palette.colors.shadowStrong}`};
`;

export const SectionTitle = styled.div.attrs({})`
  font-family: Gilroy;
  font-size: 18px;
  font-weight: 700;
  color: ${p => p.theme.palette.colors.text};
`;

export const SectionMeta = styled.div.attrs({})`
  font-family: Lato;
  font-size: 13px;
  line-height: 1.5;
  color: ${p => p.theme.palette.colors.subdued};
`;

export const PreviewFrame = styled.div.attrs({})`
  overflow: hidden;
  border-radius: 12px;
  border: 1px solid ${p => p.theme.palette.colors.borderSoft};
  background: ${p => p.theme.palette.colors.surfaceSoft};
`;

export const PreviewImage = styled.img.attrs({})`
  width: 100%;
  aspect-ratio: 16 / 9;
  object-fit: cover;
  display: block;
`;

export const ResourceList = styled.div.attrs({})`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const ResourceItem = styled.div.attrs({})`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 14px;
  border-radius: 14px;
  border: 1px solid ${p => p.theme.palette.colors.borderSoft};
  background: ${p => p.theme.palette.colors.surfaceSoft};
`;

export const ResourceTitleRow = styled.div.attrs({})`
  display: flex;
  gap: 12px;
`;

export const ResourceType = styled.div.attrs({})`
  width: 36px;
  min-width: 36px;
  height: 36px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${p => p.theme.palette.colors.badgeMuted};
`;

export const ResourceTitle = styled.div.attrs({})`
  font-family: Gilroy;
  font-size: 15px;
  line-height: 1.35;
  font-weight: 700;
  color: ${p => p.theme.palette.colors.text};
`;

export const ResourceMeta = styled.div.attrs({})`
  margin-top: 4px;
  font-family: Lato;
  font-size: 13px;
  line-height: 1.45;
  color: ${p => p.theme.palette.colors.subdued};
`;

export const ResourceAction = styled.div.attrs({})`
  display: flex;
  justify-content: flex-start;
`;

export const EmptyText = styled.div.attrs({})`
  font-family: Lato;
  font-size: 14px;
  line-height: 1.6;
  color: ${p => p.theme.palette.colors.subdued};
`;
